// Generic imports
import React from "react"
import Select from "./select"

export default function SelectDay(props) {
  return (
    <Select {...props}>
      <option value={1}>Minggu</option>
      <option value={2}>Senin</option>
      <option value={3}>Selasa</option>
      <option value={4}>Rabu</option>
      <option value={5}>Kamis</option>
      <option value={6}>Jumat</option>
      <option value={7}>Sabtu</option>
    </Select>
  )
}
